import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { Subject } from "rxjs";
import { FileDetailPreviewStyle, FileDetailType } from "ng/src/app/files/file-details/file-details.model";
import { AppStateService } from "ng/src/app/core/services/app-state.service";
import { Nullable } from "ng/src/app/shared/model/app.model";

@Component({
	templateUrl: './file-details.component.html',
	styleUrls: ['./file-details.component.scss'],
	selector: 'lb-file-details[file]'
})
export class FileDetailsComponent implements OnInit, OnDestroy {
	@ViewChild('videoEl') videoElement?: ElementRef<HTMLVideoElement>;
	@ViewChild('audioEl') audioElement?: ElementRef<HTMLAudioElement>;
	
	@Input() showDetails = true;
	@Input() showPreview = true;
	@Input() autoPlayMedia = false;
	@Input() preloadMedia: 'none' | 'metadata' | 'auto' = 'metadata';
	@Input() muted = true;
	@Input() startTime: Nullable<number> = null;
	
	@Input() detailStyle?: CSSStyleDeclaration;
	@Input() previewStyles: FileDetailPreviewStyle = {
		[FileDetailType.Type.PDF]: { height: '100%' }
	};
	
	@Input()
	get file(): FileAttachment {
		return this._file;
	}
	set file(fa: FileAttachment) {
		this.type = FileDetailType.getType(fa.contentType ?? '');
		this.canPlayType = FileDetailType.canPlayType(fa.contentType ?? '');
		
		const src = `/api/files/${fa.id}`;
		switch (this.type) {
			case FileDetailType.Type.PLAIN_TEXT:
			case FileDetailType.Type.PDF:
			case FileDetailType.Type.IMAGE:
				this.srcUrl = `${src}?inline=true`
				break;
			case FileDetailType.Type.VIDEO:
			case FileDetailType.Type.AUDIO:
				let url = `${src}?inline=true`;
				if (typeof this.startTime === 'number')
					url = `${src}#t=${this.startTime}`;
				
				this.srcUrl = url;
				break;
			default:
				this.srcUrl = src;
		}
		this.size = FileAttachment.humanReadableFileSize(fa.fileSize);
		this._file = fa;
	}
	
	@Input() get showDownload() {
		return this._showDownload;
	}
	set showDownload(val) {
		this._showDownload = val;
		this.updateMediaControls();
	}
	
	@Output() currentTimeChange = new EventEmitter<number>();
	
	get usingSafari() {
		return AppStateService.usingSafari;
	}
	
	readonly AppStateService = AppStateService;
	
	srcUrl = '';
	type = FileDetailType.Type.UNKNOWN;
	canPlayType = false;
	mediaControls = '';
	size = '';
	
	readonly TYPES = FileDetailType.Type;
	
	private _file!: FileAttachment;
	private _showDownload = true;
	private onDestroy$ = new Subject();
	
	
	ngOnInit(): void {
	
	}
	
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	
	updateMediaControls() {
		const controls: string[] = [];
		if (!this.showDownload)
			controls.push('nodownload');
		
		this.mediaControls = controls.join(' ');
	}
	
	download() {
		FileAttachment.download(this.file);
	}
	
	updateTime() {
		let currentTime: number | undefined = undefined;
		if (this.type === this.TYPES.VIDEO) {
			currentTime = this.videoElement?.nativeElement?.currentTime;
		}
		else if (this.type === this.TYPES.AUDIO) {
			currentTime = this.audioElement?.nativeElement?.currentTime;
		}
		if (typeof currentTime === 'number') {
			this.currentTimeChange.next(currentTime);
		}
	}
}

